/**
 * Gedeelde dropdown-positionering voor Select + Combobox (issue #132-
 * feedback): de portal-lijst opent onder de trigger, tenzij daar te weinig
 * ruimte is en er boven méér is — en de hoogte wordt geklemd op de
 * beschikbare ruimte zodat de lijst nooit buiten de viewport valt.
 */

export interface DropdownPosition {
  top?: number;
  bottom?: number;
  left: number;
  width: number;
  maxHeight: number;
}

/** Spiegelt de 18rem max-height van de dropdown/optionList in de module-CSS. */
const MAX_DROPDOWN_PX = 288;
/** Ruimte tussen trigger en dropdown. */
const DROPDOWN_MARGIN = 4;
/** Minimale afstand tot de viewport-rand. */
const VIEWPORT_PADDING = 8;

export function measureDropdown(rect: DOMRect): DropdownPosition {
  const spaceBelow = window.innerHeight - rect.bottom - DROPDOWN_MARGIN - VIEWPORT_PADDING;
  const spaceAbove = rect.top - DROPDOWN_MARGIN - VIEWPORT_PADDING;
  const openBelow = spaceBelow >= Math.min(MAX_DROPDOWN_PX, 160) || spaceBelow >= spaceAbove;
  const space = openBelow ? spaceBelow : spaceAbove;
  const maxHeight = Math.max(80, Math.min(MAX_DROPDOWN_PX, space));

  return openBelow
    ? { top: rect.bottom + DROPDOWN_MARGIN, left: rect.left, width: rect.width, maxHeight }
    : { bottom: window.innerHeight - rect.top + DROPDOWN_MARGIN, left: rect.left, width: rect.width, maxHeight };
}
